import { COUNT_ITEMS_LOAD_PER_PAGE } from '@/common/constants/count'

export const searchInitialState = {
  items: [],
  currentLayoutType: 'grid',
  isLoadingItems: true,
  isFiltersLoading: false,
  isErrorLoadingItems: false,
  isInfiniteScroll: true,
  currentPage: 1,
  countPages: 100,
  itemsPerPage: COUNT_ITEMS_LOAD_PER_PAGE,
  selectedItem: null,
  filtersConfig: null,
  filtersConfigMap: null,
  pagesMap: {},
  isInitialFilters: false,
  filtersParams: null,
  pagination: {
    page: 1,
    limit: COUNT_ITEMS_LOAD_PER_PAGE,
    total: 0,
    totalItems: 0,
    totalPages: 0,
  },
  paginationParams: {
    page: 1,
    limit: COUNT_ITEMS_LOAD_PER_PAGE,
  },
  sortingType: 'creation_date',
  errorId: null,
}
